import React, {Component, createRef} from "react";
import styles from './FJPhotoSearchView.module.less';
import classNames from 'classnames';
import FJPhotoItem from "./FJPhotoItem";
import FJLocalStore from "../../../../../store/FJLocalStore";
import FJSearchCommonView from "../FJSearchCommonView";
import FJWaterfall from "../../../../../common/component/FJWaterfall";

class FJPhotoSearchView extends Component {

  constructor(props) {
    super(props);
    this.layout = createRef();
    this.timer = null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {active} = this.props;
    if (prevProps.active !== active && active) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.layout.current && this.layout.current.updateUI();
      }, 300);
    }
  }

	render() {

		let {
			slectedIds,
			active,
			collections,
			onSearch,
			onPreview,
			onSubmit,
			total,
			keywords,
			viewInfo,
			searchStatus,
			searchNextPage,
			onRetry,
		} = this.props

		let {
			baseWidth,
		} = viewInfo

		return (
			<div className={classNames(styles.photo_search_container, {[styles.active]: active})}>
				<FJSearchCommonView keywords={keywords}
				                    onRetry={onRetry}
				                    status={searchStatus}
				                    searchNextPage={searchNextPage}
				                    className={styles.search_view}
                            info={{total, type: FJLocalStore._('photos')}}
				                    renderList={() => {
					                    return (
						                    <div className={styles.content}>
							                    <FJWaterfall baseWidth={baseWidth}
                                               ref={this.layout}
							                                 sizes={collections.map(c => {
							                                 	return {width: c.width, height: c.height};
							                                 })}
							                                 space={0}
							                                 render={(rects) => {
								                                 let items = [];
								                                 collections.map((item, index) => {
									                                 const rect = rects[index] || {x: 0, y: 0, width: 0, height: 0};
									                                 const {id, user, urls, width, height} = item;
									                                 const {name, links} = user;
									                                 const {raw, regular} = urls;
									                                 const fullUrl = raw + (width / height >= 1 ? "&w=1920" : "&h=1920");
									                                 return items.push(
										                                 <FJPhotoItem key={id + index}
										                                              onPreview={onPreview}
										                                              selected={slectedIds.includes(id)}
										                                              id={id}
										                                              originWidth={item.width}
										                                              originHeight={item.height}
										                                              description={item.description || item.alt_description}
										                                              userName={name}
										                                              userHtml={links.html}
										                                              fullUrl={fullUrl}
										                                              regularUrl={regular}
										                                              url={regular}
										                                              onSearch={onSearch}
										                                              onSubmit={onSubmit}
										                                              x={rect.x}
										                                              y={rect.y}
										                                              width={rect.width}
										                                              height={rect.height}
										                                 />
									                                 )
								                                 })
								                                 return items;
							                                 }}/>
						                    </div>
					                    );
				                    }}
				/>
			</div>
		)
	}
}

export default FJPhotoSearchView;